/**
 * --------------------------------------------------------------------
 * jQuery-Plugin parallaxFG
 * Version: 1.0
 * 
 * Parallax effect for forground elements
 *
 * by Lance Oliver Cummings, lance@glance.ca
 *
 * 
 *
 * --------------------------------------------------------------------
 * Changelog:
 * v 1.0, 04.05.2017
 *    
 * --------------------------------------------------------------------
 */
 

(function($) {

    $.fn.parallaxFG = function(options) {
        var settings = $.extend( {
            offsetIntertia: .15,
            offsetPosition: 0,
            axis: 'y',
            transformStyles: 'none',
            breakpoint : false  
        }, options);
        
        var $window = $(window);
        var $self = this;
        var axis = settings.axis == 'y' ? 'translateY' : 'translateX';
        var is_below_breakpoint = false;
        var transition_reset = settings.transformStyles && settings.transformStyles != 'none' ? settings.transformStyles + ' ' + axis + '(' + settings.offsetPosition + ')' : axis + '(' + settings.offsetPosition + ')';
        
        function scrollcheck() {
            if (is_below_breakpoint) {
                $self.css('transform', transition_reset);

            } else {
                scrollOffset();    
            }
        }

        function scrollOffset() {
            var pos = Math.round( distanceFromView() * settings.offsetIntertia ) + settings.offsetPosition;
            var transition = settings.transformStyles && settings.transformStyles != 'none' ? settings.transformStyles + ' ' + axis + '(' + pos + 'px)' : axis + '(' + pos + 'px)';
            $self.css('transform', transition);
        }

        function distanceFromView() {
            return $window.scrollTop() - $self.parent().offset().top;
        }

        $window.on('scroll.parallax', scrollcheck).on('resize.parallax', scrollcheck);

        if (!is_below_breakpoint) {
            scrollOffset();
        }

        function checkBreakpoint(obj, media) {
            if (settings.breakpoint) {
                is_below_breakpoint = !media[settings.breakpoint];
            }
        }
        $.subscribe("breakpoints", checkBreakpoint);
        
        return this;
    }
    
})(jQuery);
